import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { WishlistPreviewComponent } from '@app/core/header/components/wishlist-preview/wishlist-preview.component';
import { UsersService } from '@vestiaire/api-sdk-angular';
import { PopinErrorComponent } from './popin-error/popin-error.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [CommonModule, RouterModule, MatDialogModule, SharedModule],
  declarations: [WishlistPreviewComponent, PopinErrorComponent],
  exports: [WishlistPreviewComponent, PopinErrorComponent],
  providers: [UsersService],
  entryComponents: [PopinErrorComponent]
})
export class WishListPreviewModule {}
